<template>
    <div class="main">
        <a-row class="container" :gutter="8">
            <a-col :span="16">
                <a-form :form="form" @submit="handleSubmit">
                    <a-form-item label="分享平台" :label-col="{ xl: {span: 5}, xxl: {span: 4} }" :wrapper-col="{ xl: {span: 16}, xxl: {span: 16} }">
                        <!--<a-select-->
                        <!--v-decorator="[-->
                        <!--'select',-->
                        <!--{rules: [{ required: true, message: '请选择平台' }]}-->
                        <!--]"-->
                        <!--placeholder="请选择平台"-->
                        <!--&gt;-->
                        <!--<a-select-option v-for="(item, id) in shareChannel" :key="id" :value="id">-->
                        <!--{{item}}-->
                        <!--</a-select-option>-->
                        <!--</a-select>-->
                        <a-radio-group @change="chooseShareChannel" v-decorator="['shareChannel',{rules: [{ required: true, message: '请选择平台' }]}]">
                            <a-radio-button  v-for="(item, id) in shareChannel" :key="id" :value="1 + id">{{item}}</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="站点绑定" :label-col="{ xl: {span: 5}, xxl: {span: 4} }" :wrapper-col="{ xl: {span: 10}, xxl: {span: 10} }">
                        <a-select v-decorator="['select', {rules: [{ required: true, message: '请选择站点' }]}]" placeholder="请选择站点" @change="chooseSiteId">
                            <a-select-option v-for="(item, index) in siteList" :key="index" :value="item.siteid">
                                {{item.sitename}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :label="content1_label" :label-col="{ xl: {span: 5}, xxl: {span: 4} }" :wrapper-col="{ xl: {span: 10}, xxl: {span: 10} }">
                        <a-input :placeholder="'请输入' + content1_label" v-decorator="['content1',{rules: [{ required: true, message: '请输入' + content1_label }]}]">
                            <a-icon slot="prefix" type="edit"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item :label="content2_label" :label-col="{ xl: {span: 5}, xxl: {span: 4} }" :wrapper-col="{ xl: {span: 10}, xxl: {span: 10} }">
                        <a-input :placeholder="'请输入' + content2_label" v-decorator="['content2',{rules: [{ required: true, message: '请输入' + content2_label }]}]">
                            <a-icon slot="prefix" type="code"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item label="EncodingAESKey" :label-col="{ xl: {span: 5}, xxl: {span: 4} }" :wrapper-col="{ xl: {span: 14}, xxl: {span: 13} }" v-if="defaultShareChannelValue === 1">
                        <a-input placeholder="请输入EncodingAESKey" v-decorator="['content3',{rules: [{ required: true, message: '请输入EncodingAESKey' }]}]">
                            <a-icon slot="prefix" type="snippets"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item label="id" style="display: none;">
                        <a-input v-decorator="['id',{rules: [{ required: false, message: '请输入id' }]}]">
                        </a-input>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                        <a-button type="primary" html-type="submit">
                            配置
                        </a-button>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    export default {
        name: "MediaPublishSetting",
        data () {
            return {
                form: this.$form.createForm(this),
                siteList: [],
                shareChannel: ['微信公众号', '微博公众号', '百家号', '企鹅号'],
                defaultShareChannelValue: 1,
                content1_label: 'App Id',
                content2_label: 'App Secret',
                userInfo: {},
                defaultSettingsInfo: {},
            }
        },
        methods: {
            getSiteList () {
                this.$http.post('/api/content/sitelist', { 'deptid': this.userInfo.dept_id, 'limit': 100})
                    .then((res) => {
                        if (res.data.state === 200) {
                            this.siteList = res.data.data
                            this.$http.post('api/ApiThird/thirdLists', { site_id: this.siteList[0].siteid })
                                .then((res) => {
                                    if (res.data.state === 200) {
                                        var isFirstChannelHaveData = false
                                        for (var i in res.data.data) {
                                            this.defaultSettingsInfo[res.data.data[i].tid] = res.data.data[i]
                                            if (res.data.data[i].tid == 1) {
                                                this.setDefaultSettings(res.data.data[i])
                                                isFirstChannelHaveData = true
                                            }
                                            if (res.data.data.length - 1 === parseInt(i) && !isFirstChannelHaveData) {
                                                this.defaultShareChannelValue = 1
                                            }
                                        }
                                    }
                                })
                                .catch(() => {
                                })
                        }
                    })
                    .catch((err) => {

                    })
            },
            chooseShareChannel (event) {
                this.form.resetFields()
                this.defaultShareChannelValue = event.target.value
                this.form.setFieldsValue({shareChannel: this.defaultShareChannelValue})
                switch (this.defaultShareChannelValue) {
                    case 1:
                        this.content1_label = 'App Id'
                        this.content2_label = 'App Secret'
                        break
                    case 2:
                        this.content1_label = 'App Key'
                        this.content2_label = 'App Secret'
                        break
                    case 3:
                        this.content1_label = 'App Id'
                        this.content2_label = 'App Token'
                        break
                    case 4:
                        this.content1_label = 'App Key'
                        this.content2_label = 'App Secret'
                        break
                    default:
                        break
                }
                if (this.defaultSettingsInfo[this.defaultShareChannelValue]) {
                    this.setDefaultSettings(this.defaultSettingsInfo[this.defaultShareChannelValue])
                }
            },
            chooseSiteId (value, option) {
                this.form.setFieldsValue({select: value})
            },
            handleSubmit (e) {
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
                    } else {
                        return
                    }
                    var appkey  = values.content3 ? values.content3 : ''
                    var id = values.id ? values.id : ''
                    var postData = {id: id, 'app_id': values.content1, 'app_token': values.content2, 'app_key': appkey, 'tid': values.shareChannel, 'user_id': this.userInfo.userid, 'site_id': values.select}
                    switch (parseInt(values.shareChannel)) {
                        case 2:
                            postData = {id: id, 'app_id': '', 'app_token': values.content2, 'app_key': values.content1, 'tid': values.shareChannel, 'user_id': this.userInfo.userid, 'site_id': values.select}
                            break
                        case 4:
                            break
                    }
                    this.$http.post('api/ApiThird/thirdApi', postData)
                        .then((res) => {
                            if (res.data.state === 200) {
                                // 发布成功 全部置空
                                this.form.resetFields()
                                this.getSiteList()
                                if (id) {
                                    this.$message.success('修改成功')
                                } else {
                                    this.$message.success('配置成功')
                                }
                            }
                        })
                        .catch(() => {
                        })
                })
            },
            setDefaultSettings (settingInfo) {
                this.defaultShareChannelValue = parseInt(settingInfo.tid)
                this.form.setFieldsValue({select: settingInfo.site_id})
                this.form.setFieldsValue({shareChannel: parseInt(settingInfo.tid)})
                this.form.setFieldsValue({id: parseInt(settingInfo.id)})
                var that = this
                if (parseInt(settingInfo.tid) === 1) {
                    this.form.setFieldsValue({content1: settingInfo.app_id})
                    this.form.setFieldsValue({content2: settingInfo.app_token})
                    setTimeout(function () {
                        that.form.setFieldsValue({content3: settingInfo.app_key})
                    }, 0)
                } else {
                    switch (parseInt(settingInfo.tid)) {
                        case 2:
                            that.form.setFieldsValue({content1: settingInfo.app_key})
                            break
                        case 3:
                            this.form.setFieldsValue({content1: settingInfo.app_id})
                            break
                        case 4:
                            this.form.setFieldsValue({content1: settingInfo.app_id})
                            break
                    }
                    this.form.setFieldsValue({content2: settingInfo.app_token})
                }
            }
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted () {
            this.form.setFieldsValue({shareChannel: this.defaultShareChannelValue})
            this.getSiteList()
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        overflow-x: hidden;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 56px;
        padding-left: 20px;
    }
    .mgt10{
        margin-top: 10px;
    }
</style>
